export default __webpack_public_path__ + "images/image10.0256ab89.png";